export default "__VITE_ASSET__CM$IHOMk__"